var _style, _defs, _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScrumlrLp12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 160,
    height: 160,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".B{fill:none}.C{clip-rule:evenodd}.D{clip-path:url(#R)}.E{clip-path:url(#B)}.F{fill:#212b3e}.G{fill:#5dd362}.H{fill:#42bb53}.I{clip-path:url(#D)}.J{clip-path:url(#W)}.K{clip-path:url(#c)}.L{clip-path:url(#i)}.M{clip-path:url(#o)}.N{clip-path:url(#u)}.O{clip-path:url(#AA)}.P{clip-path:url(#AG)}")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.541-244A31.663,31.663,0,0,1,120.2-212.337v3.486a6.787,6.787,0,0,1,5.654,6.691v7.916a6.786,6.786,0,0,1-5.827,6.718,31.684,31.684,0,0,1-17.92,25.29v10.4h2.262a40.71,40.71,0,0,1,40.71,40.71v5.089H32v-5.089a40.71,40.71,0,0,1,40.71-40.71h2.262v-10.4a31.686,31.686,0,0,1-17.921-25.291,6.786,6.786,0,0,1-5.827-6.718v-7.916a6.787,6.787,0,0,1,5.654-6.691v-3.486A31.663,31.663,0,0,1,88.541-244Z",
    transform: "translate(-32 244)",
    className: "B C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-168,30.268H748.532V-2401H-168Z",
    transform: "translate(168 2401)",
    className: "B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "C"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(.19 -.475)",
    d: "M0 0h114v140H0z",
    className: "B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32-106.04H145.082V-244H32Z",
    transform: "translate(-32 244)",
    className: "B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76-150c0 17.487 14.176 31.663 31.663 31.663s31.663-14.176 31.663-31.663h0v4.523c0 17.487-14.176 31.663-31.663 31.663S76-127.99 76-145.477z",
    transform: "translate(-76 150)",
    className: "B C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.836-75.541c0 9.206 12.531 16.668 27.988 16.668s27.988-7.463 27.988-16.668c0-.764-.087-1.526-.258-2.271a40.73 40.73 0 0 1 28.528 38.855v5.057H32v-5.059A40.73 40.73 0 0 1 61.138-78c-.2.804-.302 1.63-.302 2.459z",
    transform: "translate(-32 77.998)",
    className: "B C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "G"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(.19 -.474)",
    d: "M0 0h114v46H0z",
    className: "B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "H"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32-33.9H145.082V-78H32Z",
    transform: "translate(-32 78)",
    className: "B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "I"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118-131a7.92 7.92 0 0 0 7.916 7.916h0a7.92 7.92 0 0 0 7.916-7.916",
    transform: "translate(-118 131)",
    className: "B C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "J"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120-150c0,2.5,3.038,4.523,6.785,4.523h0c3.747,0,6.785-2.025,6.785-4.523",
    transform: "translate(-120 150)",
    className: "B C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "K"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.091-170.355c1.183-2.282 3.558-3.694 6.127-3.645a6.76 6.76 0 0 1 6.117 3.623c.312.634-.132 1.154-.579.769a8.51 8.51 0 0 0-5.537-1.936c-1.957-.028-3.865.616-5.405 1.825-.505.412-1.029-.007-.723-.636z",
    transform: "translate(-92 174)",
    className: "B C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "L"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.091-170.355c1.183-2.282 3.558-3.694 6.127-3.645a6.76 6.76 0 0 1 6.116 3.623c.312.634-.132 1.154-.579.769a8.51 8.51 0 0 0-5.537-1.936c-1.957-.028-3.865.616-5.405 1.825-.504.412-1.028-.007-.722-.636z",
    transform: "translate(-150 174)",
    className: "B C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "M"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.053-185.657c2.214-3.115 8.282-4.861 13.509-3.578a1.13 1.13 0 0 0 1.368-.829 1.13 1.13 0 0 0-.828-1.368c-6.071-1.491-13.1.532-15.892 4.464a1.13 1.13 0 1 0 1.843 1.311z",
    transform: "translate(-88 191.922)",
    className: "B C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "N"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.91-185.657c-2.214-3.115-8.282-4.861-13.509-3.578a1.13 1.13 0 0 1-1.368-.829 1.13 1.13 0 0 1 .828-1.368c6.071-1.491 13.1.532 15.892 4.464a1.13 1.13 0 1 1-1.843 1.311z",
    transform: "translate(-146 191.922)",
    className: "B C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "O"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-121.685H149.269V-280H0Z",
    transform: "translate(0 280)",
    className: "B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "P"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(.337 .283)",
    d: "M0 0h85v108H0z",
    className: "B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Q"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.417-202.111a6.792,6.792,0,0,0,5.009,3.581A31.68,31.68,0,0,0,85.4-172.665v2.375a9.4,9.4,0,0,1-1.414.106,9.332,9.332,0,0,1-8.588-5.678,9.33,9.33,0,0,1-8.657-9.306,9.343,9.343,0,0,1,.313-2.406,9.333,9.333,0,0,1-6.533-8.9,9.287,9.287,0,0,1,1.8-5.51Zm75,5.635a9.333,9.333,0,0,1-6.533,8.9,9.331,9.331,0,0,1,.313,2.405,9.33,9.33,0,0,1-8.658,9.305,9.331,9.331,0,0,1-8.587,5.678,9.4,9.4,0,0,1-1.413-.106v-2.376a31.681,31.681,0,0,0,17.975-25.864,6.792,6.792,0,0,0,5.009-3.581A9.286,9.286,0,0,1,137.419-196.475ZM105.473-268a11.575,11.575,0,0,1,9.356,4.748,11.548,11.548,0,0,1,4.213-.79,11.591,11.591,0,0,1,11.591,11.591,11.69,11.69,0,0,1-.128,1.729,9.334,9.334,0,0,1,6.913,9.013,9.293,9.293,0,0,1-.906,4.016,9.32,9.32,0,0,1,4.3,7.858,9.3,9.3,0,0,1-2.905,6.765,9.313,9.313,0,0,1,.643,3.412,9.294,9.294,0,0,1-2.322,6.16,6.789,6.789,0,0,0-5.593-5.783v-.13l-.048.036c-1.641-26.662-27.413-17.105-31.618-32.045-4.2,14.94-29.973,5.383-31.614,32.045l-.047-.036v.13a6.79,6.79,0,0,0-5.594,5.783,9.294,9.294,0,0,1-2.322-6.159,9.331,9.331,0,0,1,.389-2.676,9.316,9.316,0,0,1-3.782-7.5,9.33,9.33,0,0,1,5.2-8.37,9.3,9.3,0,0,1-.681-3.5,9.333,9.333,0,0,1,6.913-9.013,11.686,11.686,0,0,1-.128-1.729A11.591,11.591,0,0,1,78.9-264.042a11.562,11.562,0,0,1,4.214.79A11.575,11.575,0,0,1,92.469-268a11.537,11.537,0,0,1,6.5,1.994A11.534,11.534,0,0,1,105.473-268Z",
    transform: "translate(-56 268)",
    className: "B C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "R"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32-121.685H145.082V-280H32Z",
    transform: "translate(-32 280)",
    className: "B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "S"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(.043 -.358)",
    d: "M0 0h14v13H0z",
    className: "B"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "T",
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 22"
  }, /*#__PURE__*/React.createElement("image", {
    width: 24,
    height: 22,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAWCAYAAADafVyIAAAABHNCSVQICAgIfAhkiAAAAQtJREFUSInN1V1PwjAUxvGfMEFUNGpCTPDC7/+5vDBekYkvGAdetMTZFBhLL3ySpW22nX/PS0+H/moexy+FVCXraRxfSwEGyfodF6WM5wA1zuLT1lDw9uRYQBqiGg1mcX6PUfLNGh94xtshQG5Hs2i4iz7xJIQ2q+EO6E1HQIXbOM96kwPMMOkI2Ooy/rNIX6RJ5rdUj9UVHg4BBjjtCSCE624fIK2qPpq37aSApgAAHvcBvgsAzsVCySW5LgAgJjwHeMGmAGCCKncOGqFdXxeADHIAQgtYCbV9dINrabQLsIUshGY37mF8g2XX3Y2FAzQ9AGuwFAqlRtPH/Uq4LyqhSNbR8ErBq/b/6AcB2Sghq6DuNwAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "U"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(.043 -.368)",
    d: "M0 0h14v13H0z",
    className: "B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "V"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.513-221.949s-2.816 4.992 3.055 7.129a10.27 10.27 0 0 0 7.628-.662s-1.22-5.6-5.633-7.208c-3.453-1.257-5.05.741-5.05.741z",
    transform: "translate(-176.838 223.105)",
    className: "B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "W"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171-213.734h16.962V-229H171Z",
    transform: "translate(-171 229)",
    className: "B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "X"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.865-217.086s-1.22-5.6-5.633-7.208a4.819,4.819,0,0,0-4.536.283,5.583,5.583,0,0,1-.82-2.4.357.357,0,0,0-.262-.353.248.248,0,0,0-.167-.018.4.4,0,0,0-.371.423,8.369,8.369,0,0,0,2.616,4.992C182.11-217.633,187.865-217.086,187.865-217.086Z",
    transform: "translate(-176.075 226.795)",
    className: "B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Y"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-.126 .389)",
    d: "M0 0h16v11H0z",
    className: "B"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "Z",
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    viewBox: "0 0 27 21"
  }, /*#__PURE__*/React.createElement("image", {
    width: 27,
    height: 21,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAVCAYAAAC33pUlAAAABHNCSVQICAgIfAhkiAAAAQpJREFUSInl1ctKw0AUgOEvTYXULqrghaLu1G58/3dxIyjSghbvilptXUwCsaSxNrPSfzXJnMk/zJxzwl8lifCNFGv5eIYJprFkbWxiA52SqMwEz3jEHd5/K8uwh94Km3zA1TKLWuhjdwVJmZv2DwEpjtBtICkY1clSDIR7acoEr62agP1IIhgR7qOKdWxFEn3iuk62HUkEl8VgkawXSfSGcZ2s3BGaMMNp+UWVLIsggjMhCxfKMhxGEJ0Lbeob6ZxoIPS+p3yurjSqmApHd181WRR1huP8eYwL4cz72CnFLaJI72G+rpJE2P2JkBRj4Qjm6Qh1183FCT7wgluh0S5FItzTgTj/t3/IF5X4K4anb1RwAAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-.126 .379)",
    d: "M0 0h16v11H0z",
    className: "B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.986-258.739c2.987-1.725 4.18-6.33 4.18-6.33a10.02 10.02 0 0 0-8.627-.242c-4.458 2.117-3.6 5.865-3.6 5.865 2.288 1.853 5.471 2.133 8.047.707z",
    transform: "translate(-150.873 266.194)",
    className: "B C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143-255.907h18.659V-274H143Z",
    transform: "translate(-143 274)",
    className: "B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.949-256.5c.024.058.074.102.134.119a.59.59 0 0 0 .806-.074c.556-.652 1.174-1.249 1.844-1.783a6.91 6.91 0 0 0 7.52.359c2.987-1.725 4.18-6.33 4.18-6.33l-1.752.358h0c-.3.043-8.129 1.3-12.643 6.712-.167.17-.203.43-.089.639z",
    transform: "translate(-146.883 264.206)",
    className: "B C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(.495 -.369)",
    d: "M0 0h14v11H0z",
    className: "B"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "f",
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    viewBox: "0 0 26 20"
  }, /*#__PURE__*/React.createElement("image", {
    width: 26,
    height: 20,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAUCAYAAACTQC2+AAAABHNCSVQICAgIfAhkiAAAAQhJREFUSInd1E1Lw0AQxvFf01IVrVBBRaj0IPr9P49FT4ooqJcE61viYTcQmiZEG3rwgbnMLvuffWZ32JKGW2BMUPwWlGAvRoIcRcv+GeYYjzocPsZ5rGxdYd/IcIe3Sv4Mp3H9cdACGOIS+x2KKbXELY5j5LhG1gQ6xIVgz1+VY4EU1lk3EW6yiYoqhHrFOz1AREBaTayCrtDWt656X01UQTPhhfWhrAmU4KQnSI7XJtBcP5bBk/B3aqABpj1BlnhYt1Ba1tcDWAjW1TQSfvCmynCDz6YNI5tN8C/c41n7cDUQ7JviSJgKXWxM8RKj1vgmUFUJDrArTIlyRBVCD5aCTR9dDv/f+gEB+jGCZjKyjgAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(.495 -.38)",
    d: "M0 0h14v11H0z",
    className: "B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.18-226.229C83.193-224.5,82-219.9,82-219.9a10.019,10.019,0,0,0,8.627.242c4.458-2.117,3.6-5.865,3.6-5.865A7.226,7.226,0,0,0,86.18-226.229Z",
    transform: "translate(-82 227.177)",
    className: "B C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79-218.907H97.659V-237H79Z",
    transform: "translate(-79 237)",
    className: "B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.483-228.125c-.024-.058-.074-.102-.134-.119a.59.59 0 0 0-.806.074 13.35 13.35 0 0 1-1.844 1.783 6.91 6.91 0 0 0-7.52-.359c-2.987 1.725-4.18 6.33-4.18 6.33l1.752-.358h0c.3-.043 8.129-1.3 12.643-6.712.167-.17.203-.43.089-.639z",
    transform: "translate(-82 228.37)",
    className: "B C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(.39 .494)",
    d: "M0 0h15v15H0z",
    className: "B"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "l",
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    viewBox: "0 0 27 28"
  }, /*#__PURE__*/React.createElement("image", {
    width: 27,
    height: 28,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAcCAYAAACQ0cTtAAAABHNCSVQICAgIfAhkiAAAAYZJREFUSIm91l1LG0EUxvFfjBiSGJtirZfSquD3/zLSi2JLoVjEasAYxSR6MTN1Tfclm6z5w8CyZ2eemTPnZdkgrRXmtPEZQ+zgCSNcYtakWAfH6ObYpviGh7Jd1uEUvQLbFj7gGs95H2znTBhiP25kjpu4wAD9is104vzrKrE2TrC78M0Ah7irEEqk05WKHecIJTpxLEOuCwluI7hnsORiVTxViQ0bEiJE40fBE2+iPblxlXwr4ijzPMEP3PN6ssKjr0kXZ2IUJ7G/Si52TVr4glZK6nkce+8kuI1RtoKMo+CuZu8wcb+18GKspLatyTyb1D2h9i1uoCnG2YW/vqPQLR6yFWTZclSXCX7ymtRFbWMVpkJRfxRS6o8QeP/ESjtsTa7wO8+Q3DhuUGy/yJDE0pGbYKdKDH4pb5CXS4pNiwzZCpJ+AWbCXbbjxBEuhPA9UJ0et3H8R92y9MnbFrLIHOcKqlDdv6uJ0B3yuvoM38XelceqBbcvdOO+0AsnQsgX3tfGeQH8tEpB3aB32AAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(.39 .483)",
    d: "M0 0h15v15H0z",
    className: "B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "n"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.049-239.142a2.92 2.92 0 0 1 .579-4.118 2.41 2.41 0 0 1 .646-.321c-.232-.066-.454-.168-.656-.3-1.328-.933-1.651-2.764-.722-4.095s2.764-1.652 4.095-.722a2.41 2.41 0 0 1 .5.515 2.4 2.4 0 0 1 .081-.717 2.92 2.92 0 0 1 3.671-1.952c1.551.477 2.424 2.118 1.952 3.671a2.39 2.39 0 0 1-.329.636c.225-.082.461-.129.7-.141 1.623-.026 2.961 1.266 2.991 2.889.011.62-.174 1.227-.53 1.734a2.94 2.94 0 0 1-2.359 1.257 2.39 2.39 0 0 1-.706-.116 2.39 2.39 0 0 1 .351.624 2.94 2.94 0 0 1-.375 2.646c-.355.508-.862.89-1.448 1.091-1.535.527-3.207-.289-3.737-1.823a2.39 2.39 0 0 1-.108-.708c-.134.199-.298.377-.485.527a2.92 2.92 0 0 1-4.111-.577z",
    transform: "translate(-66.364 250.979)",
    className: "B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "o"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66-236.038H80.7V-253H66Z",
    transform: "translate(-66 253)",
    className: "B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "p"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.136-243.171a.817.817,0,0,0-.542-1.02.817.817,0,0,0-1.02.542,11.836,11.836,0,0,0,.131,2.364A11.82,11.82,0,0,0,77.136-243.171Zm1.268,3.278a.817.817,0,0,0,.8-.831.817.817,0,0,0-.831-.8,11.838,11.838,0,0,0-2.208.855A11.847,11.847,0,0,0,78.4-239.893Zm-3.425-1.141a11.828,11.828,0,0,0-1.352-1.944.817.817,0,0,0-1.137.2.817.817,0,0,0,.2,1.137A11.829,11.829,0,0,0,74.98-241.035Zm1.737,3.866a.817.817,0,0,0,.506-1.038,11.815,11.815,0,0,0-1.5-1.836,11.836,11.836,0,0,0-.049,2.368A.817.817,0,0,0,76.717-237.168Zm-3.008-1.109a11.82,11.82,0,0,0,1.284-1.99,11.836,11.836,0,0,0-2.267.685.817.817,0,0,0-.161,1.144A.816.816,0,0,0,73.709-238.277Z",
    transform: "translate(-72.342 244.227)",
    className: "B C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "q"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-.484 .42)",
    d: "M0 0h24v23H0z",
    className: "B"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "r",
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    viewBox: "0 0 42 42"
  }, /*#__PURE__*/React.createElement("image", {
    width: 42,
    height: 42,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAqCAYAAADFw8lbAAAABHNCSVQICAgIfAhkiAAAAmpJREFUWIXVmU2P0zAQhp+UpkvTXcQSictKCBBc+P8/hgMSCFgJFm21/UjabWnDYWI1pJPETtI0+1ySOo79xh7PjF14IngN3x8DAfAc+As8AnNg37DdI+oKvQRu0mueLfAbuAOSmu0f8azGO9fAB+CipM0X6fNZTV1qoy5MgI/YzcQYGAEPufIhYi5+2s7OpuOhvUY84I1DfYAQWALT9D5EPjZLhJjJtKpzW8bAJ4f6hj1iq1Wzdw98p2AhuozolUPdLAPLemF6/dakEZARPTUh8Ep74CLUb0dLJa+1wqKp9xAnfoWMpE/9qXdlgniLTbZQEzpBVnfQgagifCqEXgPvO5NTzJE3ytroJfCuOy2lrPMFWaE3NE9S2iBCEpz/MEID9ATjHNxrhUZoPqydix0VQosyoa7xKHD4Jv4GSGp2bjzgJUqKaIT6iGvqCwE5sUboBgldLiH11IwRm43gINRsGfow/VkC4A+QZHPEiMNGrS8MgBhY55PZB8Q2ukjpbImBKC80QcRuETPoQ6SKgUXR4pnS4la3IWsoXuUh9bbSpyCGcqF9YAmsQBc6pB+xPwF+mh+a0L64p6+kzh70rci5F1EE/CAjEnSh207kCHtgkfa5Su9XWkVN6Ab5mi7sdAF8salYtOrv2tNSivXslTl8NdNuGXWaNcqc+hw5CKja35tjwzrh9hZlI6dRJtTE/UdE8Cj3PAJ+IYdaWyQzdyFO37fCZRRGHA5f1xyPxFvcItpnci6oDJd4vkNGboN+hjnDLkVMEGc+d+i79cRjhnxQgL5Ql4ipOImE0+WbAw5/OAwRU4lxWOVPln818nAKMCJYKAAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "s"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-.484 .41)",
    d: "M0 0h24v23H0z",
    className: "B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "t"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.444-245.1l.146-1.308,1.308-.147a4.026,4.026,0,0,0,3.423-2.72,4.088,4.088,0,0,0-1.44-4.683l-1.06-.78.527-1.206a4.039,4.039,0,0,0-.86-4.558,4.04,4.04,0,0,0-4.558-.86l-1.206.527-.78-1.06a4.091,4.091,0,0,0-4.683-1.44,4.025,4.025,0,0,0-2.719,3.423l-.146,1.308-1.308.147a4.026,4.026,0,0,0-3.423,2.72,4.066,4.066,0,0,0,.944,4.257h0a4.354,4.354,0,0,0,.5.425l1.06.78-.528,1.206a4.041,4.041,0,0,0,.861,4.558,4.041,4.041,0,0,0,4.558.861l1.206-.528.78,1.06a4.089,4.089,0,0,0,4.683,1.44A4.026,4.026,0,0,0,103.444-245.1Z",
    transform: "translate(-86.423 263.572)",
    className: "B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "u"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86-241.122h22.616V-266H86Z",
    transform: "translate(-86 266)",
    className: "B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "v"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.585-244.109a.814.814,0,0,1-.576,1,.814.814,0,0,1-1-.576c-.116-.434-.056-3.356-.056-3.356s-1.409,2.561-1.727,2.879a.815.815,0,0,1-1.151,0,.815.815,0,0,1,0-1.151c.318-.318,2.879-1.727,2.879-1.727s-2.922.06-3.356-.056a.814.814,0,0,1-.576-1,.814.814,0,0,1,1-.576c.434.116,2.935,1.629,2.935,1.629s-1.513-2.5-1.629-2.935a.814.814,0,0,1,.576-1,.814.814,0,0,1,1,.576c.116.434.056,3.356.056,3.356s1.409-2.561,1.727-2.879a.814.814,0,0,1,1.151,0,.814.814,0,0,1,0,1.151c-.318.318-2.879,1.727-2.879,1.727s2.922-.06,3.356.056a.814.814,0,0,1,.576,1,.814.814,0,0,1-1,.576c-.434-.116-2.935-1.629-2.935-1.629S104.469-244.544,104.585-244.109Z",
    transform: "translate(-98.996 251.004)",
    className: "B C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "w"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-.063 .474)",
    d: "M0 0h21v22H0z",
    className: "B"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "x",
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    viewBox: "0 0 38 39"
  }, /*#__PURE__*/React.createElement("image", {
    width: 38,
    height: 39,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAnCAYAAABjYToLAAAABHNCSVQICAgIfAhkiAAAAktJREFUWIXN2F1PE1EQxvFfWyxQglCRCL5cmGg0fv/P4o0aTTRRDG8KCLS2eDGndItdOG1hy5M07XanPf+dnTMzO9xT1ab4TR2P0MZyOu7iGLs4mQfYCl5i8Rqb7+l1MS0UNCawXcQbPLjBblV48pcZ4HLBGniNZqb9krgbR9NAwUKm3abwwiR6gh38Lay1JjxfQwe/cT4L2MaEUNLi6zjEMzwusTvEN1cAc25lHS+mACN265bwVJmWxIUfCy9eLpoDNq020cqwa+CVQgznLNo349bPVAPPBwe5YH/uDGdUbSnurwOriZzVFLurKq0yflcuGwbsYHP8HWN3V2ryP9g2no4xzk0rt6ELRm9lGVTVOmMItuJ+QPVEPrsE254fy4h2RBZQFwH+cK44oRP8GBwsGBbVeeoInxQSeZW7bZz6+CwK+Yga6eRW1URJNRFGXZwWTzSE+zbMz3t1UYq6CqVvkNkvXN+aVKE1HEhVZgB2plBA56RaWv+QYR7r44NCozYnrUsZotjB9rAviuik/f1tqSbdzqutdV+4ck9471wkvo7qYPfRKYupDn6mzzW8qwQp1CWvg22JB4Yq1JXiPAds5W5ZRrRnTD9WpqrqaFehiOeAzdJWf8206+FjekdeQp12/tATG6grHpjLhjEn+CJ1rpOAdRLc6oRgu+n9QEx+2uk/miKOTtP3Yy88N35aeDuBfRfvzRAGuWOoQeVvuxluEC9jpzi5mmRwdy7c3lIeL8eiEz0tOZ+taVPBmmjwBkOQM1HKbmX+eq/1D+ybc2JGafaFAAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "y"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-.063 .463)",
    d: "M0 0h21v22H0z",
    className: "B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "z"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.976-237.125a4.16 4.16 0 0 0 .8-3.1c-.151-1.1-.737-2.093-1.625-2.759a3.43 3.43 0 0 0-.919-.457 3.42 3.42 0 0 0 .934-.424 4.19 4.19 0 0 0 1.028-5.827 4.19 4.19 0 0 0-5.827-1.027c-.275.207-.517.454-.718.733.013-.344-.025-.688-.115-1.02-.322-1.063-1.055-1.953-2.037-2.471a4.16 4.16 0 0 0-3.188-.307 4.19 4.19 0 0 0-2.778 5.224 3.4 3.4 0 0 0 .469.9 3.39 3.39 0 0 0-1-.2 4.19 4.19 0 0 0-4.257 4.111c-.016.881.248 1.745.754 2.467a4.18 4.18 0 0 0 3.356 1.789 3.4 3.4 0 0 0 1-.166 3.4 3.4 0 0 0-.5.888 4.18 4.18 0 0 0 .533 3.766 4.16 4.16 0 0 0 2.061 1.552 4.19 4.19 0 0 0 5.318-2.594 3.4 3.4 0 0 0 .153-1.007 3.4 3.4 0 0 0 .69.75c.885.67 2.001.958 3.1.8 1.102-.148 2.1-.732 2.768-1.621z",
    transform: "translate(-155.744 253.97)",
    className: "B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "AA"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155-232.818h20.92V-256H155Z",
    transform: "translate(-155 256)",
    className: "B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "AB"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.643-242.859a1.16 1.16 0 0 1 .772-1.451 1.16 1.16 0 0 1 1.451.772c.05 1.125-.012 2.252-.187 3.365a16.82 16.82 0 0 1-2.036-2.686zm-1.8 4.665a1.16 1.16 0 0 1-1.142-1.182 1.16 1.16 0 0 1 1.182-1.142 16.84 16.84 0 0 1 3.142 1.217 16.86 16.86 0 0 1-3.187 1.106zm4.874-1.624a16.83 16.83 0 0 1 1.924-2.766 1.16 1.16 0 0 1 1.619.285 1.16 1.16 0 0 1-.285 1.619 16.83 16.83 0 0 1-3.263.861zm-2.473 5.5a1.16 1.16 0 0 1-.721-1.477c.62-.94 1.334-1.815 2.129-2.612.136 1.118.159 2.247.069 3.369-.1.292-.313.533-.591.668s-.598.154-.89.053zm4.28-1.578a16.82 16.82 0 0 1-1.827-2.832c1.105.216 2.185.543 3.225.975a1.16 1.16 0 0 1 .229 1.628 1.16 1.16 0 0 1-1.631.231z",
    transform: "translate(-165.696 244.362)",
    className: "B C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "AC"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-.315 .315)",
    d: "M0 0h32v31H0z",
    className: "B"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "AD",
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    viewBox: "0 0 57 56"
  }, /*#__PURE__*/React.createElement("image", {
    width: 57,
    height: 56,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADkAAAA4CAYAAABHRFAgAAAABHNCSVQICAgIfAhkiAAAA0RJREFUaIHtmm9T00AQh5+W0vJnKCIKzuCoiH7/r+I7X6Ed0RmtiEhpSyklvtiEHiF3uUvuTML4zECZ5nrsr9nb7O0t/Odx0KragJg1YAdYB3pAG5gDM+AXcFlm8ipFtoBdYA8RZ2IKfI5fC/0jF1aQb3wb6AIdYAHcABPkGx/F75nYAV7Gc9hyiwg9dzPZXmQLeBH/tC2M+QMMeehmXeA10HewUSUCPuJ4R21EdoC3wFYBo8bAN+Tu7iACVwrMozJFhEa2H8gT2QLeU0ygyhjYLDmHyifgt+3gPNc7oLxA8CsQ4JnLYJPIHrBfzpZg9HFwe5PI5+VtCcqG7UCTyF0PhoQk79l6h07kKhJV68yq7UCdyDVPhoSk9JrMi7p1wDpb04mxftBWiLWNOpF5uWcdsLZRJ/LKkyEhubEdaLqT135sCcbMdqApwIw8GBKSDSyDjykMt5CdQ13ZQtK73P2rSeQ1krvWpUSSRRdJ1mcY4ohJZIQk6dY5YkUkHhehqQXlZQ1dpNTRBJJqwwOhJpHbwBvq7a5ptpD1OVbf1IncBN7RjPQuTR+4QEqaQLaIDnCkudYEWsAhigdmCTnEYRtTU3oo++G0yKcULxfWjbvSjSqyjRR8HwtrxB6pityl+W6aZhPui9yryJCQtO9+IQ/9JpQ8XJnDUuRjCTZpZrAU2avQkFCMiPfEicimPvhNDJM/EnFNKFy5cI4cHwJLkZNqbAnCFTBAuXFJlXycNbqBXALHpCoFyS5kgWxTmhqAIuAHcgdv0xfVrdaE+p9kpYmQw1jjoWx6Q3yA9AXUnTESXE6xqL9m7fr3qV+iPkKEjZF1Z11YBn1pow+8oh5rNAI+kLHWbNGVP2bAT5atJKtUlzBcIF1ZhXEpUnWQJD5pC0s+u4ivhXLxASVFupwm3yDrQdfn1sd/or/AoZVFh08X/EKJdaPh1MecPkXOgBOP80UoSXYZfAeTUwo0+GkY4un4METEHFA+4Z8D38ubIpRt5ssiQrY5TyjeJnOMx9PuECJBgsU5kvS7VgC/Amc+jQklEiT8nyF307aB8ARPwUYlpEhYuu4UqQjqOpUniIv6Clr3+NfHcutIwpC0tU1ZJt7BSjB/AQuVj94OfRt/AAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "AE"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-.315 .295)",
    d: "M0 0h32v32H0z",
    className: "B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "AF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.774-262.111c1.032-3.948-3.389-7.019-5.062-8.02.291-1.659.946-7.1-2.526-9.112-3.452-2-7.8 1.246-9.112 2.345l-.4-.239c-1.734-1-6.088-3.026-9.074-.133-3.192 3.092-1.308 7.917-.591 9.441-1.221 1.137-4.741 4.858-3.29 8.815.4 1.091 1.179 2.002 2.195 2.566 2.279 1.319 5.432 1.107 6.628.965A13.5 13.5 0 0 0 128-250.36c.862.525 1.859.786 2.867.749 3.9-.2 5.607-5.651 6.033-7.3 1.622-.225 6.838-1.244 7.874-5.2z",
    transform: "translate(-114.377 279.88)",
    className: "B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "AG"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114-249.206h31.1V-282H114Z",
    transform: "translate(-114 282)",
    className: "B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "AH"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.7-258.355s2.084 4.629.2 4.925-.826-4.858-.826-4.858-4.021 3.4-4.608 1.712 4.354-2.289 4.354-2.289-4.516-2.653-3.05-3.865 3.515 3.444 3.515 3.444 1.1-5.043 2.725-4.1-2.181 4.417-2.181 4.417 5.019-.56 4.732 1.33-4.861-.716-4.861-.716z",
    transform: "translate(-132.422 263.504)",
    className: "B C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "AI"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190.565-151c.312 0 .565.253.565.565v13.57c0 .312-.253.565-.565.565s-.565-.253-.565-.565v-13.57c0-.312.253-.565.565-.565z",
    transform: "translate(-190 151)",
    className: "B C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "AJ"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.566-126.3a3.7 3.7 0 0 0-.131-2.82 3.94 3.94 0 0 0-1.974-1.426c-.552-.13-1.133-.05-1.629.224a5.43 5.43 0 0 0-1.7 1.322c-1.836 1.981-4.581 6.682-3.461 9.934.84 2.439 4.6 2.076 6.783 2.557a.66.66 0 0 1 .371.993 2.36 2.36 0 0 1-1.135 1.014c-1.384.69-3.371.281-4.567-.02a3.08 3.08 0 0 0-2.068.33c-.253.121-.493.269-.715.441-.293.286-.37.632.1.873a8.25 8.25 0 0 0 7.031.19c1.25-.565 2.247-1.571 2.8-2.826.341-.743.437-1.576.273-2.377-.191-.475-.628-.807-1.137-.862-1.161-.206-4.9.062-5.372-1.552-.827-2.809 3.191-8.93 4.3-8.725.416.072.134 1.445-.159 2.628a5.59 5.59 0 0 0-.242 3.035c.16.478.538.851 1.018 1.005.618.252.816-.07.9-.56.136-.741.4-2.329.709-3.38",
    transform: "translate(-181.106 130.605)",
    className: "B C"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#c000ff",
    d: "M0 0h160v160H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.093 22.04)",
    clipPath: "url(#A)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-113.082 -1219.592)",
    className: "E"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(112.799 1219.026)",
    clipPath: "url(#C)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.283 .565)",
    className: "I"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-.565-.565h114.213v139.091H-.565z",
    fill: "#cfc6ac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-.565-.565h114.213v139.091H-.565z",
    fill: "#d08a5a"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.161 53.714)",
    clipPath: "url(#E)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-24.878 -53.149)",
    className: "I"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.313 52.583H88.77V89.9H24.313z",
    fill: "rgba(0,0,0,0.1)"
  }))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.093 115.899)",
    clipPath: "url(#F)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-113.082 -1313.451)",
    className: "E"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(112.799 1313.026)",
    clipPath: "url(#G)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.283 .424)",
    clipPath: "url(#H)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-.565-.565h114.213v45.233H-.565z",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-.565-.565h114.213v45.233H-.565z",
    fill: "#ff0668"
  })))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(72.719 85.931)",
    clipPath: "url(#I)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-161.708 -1283.483)",
    className: "E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.142 1282.918h16.962v9.047h-16.962z",
    fill: "rgba(255,255,255,0.8)"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(73.849 75.188)",
    clipPath: "url(#J)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-162.838 -1272.741)",
    className: "E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.273 1272.175h14.7v5.654h-14.7z",
    fill: "rgba(0,0,0,0.16)"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(58.018 61.619)",
    clipPath: "url(#K)",
    className: "F"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-147.007 -1259.171)",
    className: "E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.227 1258.605h13.992v5.907h-13.992z"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(90.812 61.619)",
    clipPath: "url(#L)",
    className: "F"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-179.801 -1259.171)",
    className: "E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.02 1258.605h13.992v5.907H179.02z"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(55.756 51.485)",
    clipPath: "url(#M)",
    className: "F"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-144.745 -1249.038)",
    className: "E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.027 1247.472h18.362v9.024h-18.362z"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.55 51.485)",
    clipPath: "url(#N)",
    className: "F"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-177.539 -1249.038)",
    className: "E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.858 1256.496h18.362v-9.024h-18.362z"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(6 1.685)",
    clipPath: "url(#O)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.663 -2.968)",
    clipPath: "url(#P)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 9.753)",
    clipPath: "url(#Q)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-13.57 -6.785)",
    className: "D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.004 6.22h85.943v98.947H13.004z",
    fill: "#1e3540"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(66.294 33.642)",
    clipPath: "url(#S)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#T)",
    d: "M.043-.358h14v13h-14z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-13.57 2.968)",
    className: "D"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(79.864 29.684)",
    clipPath: "url(#U)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.029 2.485)",
    clipPath: "url(#V)",
    className: "G"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3.301 -3.333)",
    className: "J"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2.947 12.122l16.365 5.956 5.348-14.693L2.401-2.571z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.597 .399)",
    clipPath: "url(#X)",
    className: "H"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.869 -1.247)",
    className: "J"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-.988 10.156l14.605 5.316 4.892-13.441L3.904-3.285z"
  })))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(50.463 9.894)",
    clipPath: "url(#Y)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Z)",
    d: "M-.126.389h16v11h-16z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-13.57 2.968)",
    className: "D"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(64.033 5.936)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.179 1.87)",
    clipPath: "url(#b)",
    className: "G"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4.451 -4.414)",
    className: "K"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.68-3.26l8.677 15.028-15.633 9.026-8.677-15.028z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.923 2.994)",
    clipPath: "url(#d)",
    className: "H"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.196 -5.538)",
    className: "K"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.298-1.555l7.8 13.51-15.512 8.956-7.8-13.51z"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.842 32.653)",
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M.495-.369h14v11h-14z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-13.57 2.968)",
    className: "D"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.412 28.695)",
    clipPath: "url(#g)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.141 1.172)",
    clipPath: "url(#h)",
    className: "G"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.696 -5.554)",
    className: "L"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.761 21.63L-3.916 6.602l15.633-9.026 8.677 15.028z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.141 .498)",
    clipPath: "url(#j)",
    className: "H"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.696 -4.88)",
    className: "L"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.138 19.925l-7.8-13.51 15.508-8.956 7.8 13.51z"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.947 19.789)",
    clipPath: "url(#k)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M.39.494h15v15h-15z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-13.57 2.968)",
    className: "D"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.517 15.832)",
    clipPath: "url(#m)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.913 .577)",
    clipPath: "url(#n)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.206 -1.143)",
    className: "M"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-.565 16.656h15.546V.478H-.565z",
    fill: "#0057ff"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.293 4.395)",
    clipPath: "url(#p)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3.586 -4.96)",
    className: "M"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.91 12.731h8.114V4.296H2.91z",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.821 12.863)",
    clipPath: "url(#q)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "M-.484.42h24v23h-24z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-13.57 2.968)",
    className: "D"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(30.391 8.905)",
    clipPath: "url(#s)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.38 .383)",
    clipPath: "url(#t)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.239 -1.373)",
    className: "N"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-.565.442h23.747v23.994H-.565z",
    fill: "#c01eff"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.489 7.489)",
    clipPath: "url(#v)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-7.348 -8.479)",
    className: "N"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.695 7.825h9.228v9.228H6.695z",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(56.4 17.81)",
    clipPath: "url(#w)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#x)",
    d: "M-.063.474h21v22h-21z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-13.57 2.968)",
    className: "D"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(69.97 13.852)",
    clipPath: "url(#y)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.004 .866)",
    clipPath: "url(#z)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.421 -1.148)",
    className: "O"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-.159.441h21.645v22.544H-.159z",
    fill: "#c01eff"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.624 6.298)",
    clipPath: "url(#AB)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6.048 -6.58)",
    className: "O"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.472 5.882h11.069v11.521H5.472z",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.652 2.968)",
    clipPath: "url(#AC)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#AD)",
    d: "M-.315.315h32v31h-32z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-13.57 2.968)",
    className: "D"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(46.222 -1.979)",
    clipPath: "url(#AE)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.355 2.047)",
    clipPath: "url(#AF)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.213 -1.198)",
    className: "P"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-.565-.565h32.228v32.649H-.565z",
    fill: "#ff0468"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.557 11.307)",
    clipPath: "url(#AH)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-10.416 -10.458)",
    className: "P"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.311 9.069h12.1v12.323h-12.1z",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(75.765 75.906)",
    clipPath: "url(#AI)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-89.335 -72.938)",
    className: "D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.77 72.373h2.262v15.832H88.77z",
    fill: "#e5e5e5"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(70.736 87.438)",
    clipPath: "url(#AJ)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-84.306 -84.47)",
    className: "D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.594 86.069l16.8-5.784 7.4 21.485-16.8 5.784z",
    fill: "#ff0468"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrumlrLp12);
export default __webpack_public_path__ + "static/media/scrumlr-lp-12.5c078734a0c7a9c0078dd51b424e6d36.svg";
export { ForwardRef as ReactComponent };